import { labels } from '../labels.js';
import { SESSION_TOKEN_STORAGE_KEY } from '@scan2eat/shared';
import { EmptyState } from '../components/EmptyState.js';
import { Icon } from '../components/Icon.js';
import { Logo } from '../components/Logo.js';

export function SessionExpiredPage() {
  return (
    <main className="client-screen" style={{ minHeight: '100dvh', display: 'grid', gridTemplateRows: '1fr auto', padding: 'var(--space-6)' }}>
      <div style={{ display: 'grid', placeItems: 'center' }}>
        <EmptyState icon="clock" title={labels.errors.sessionExpiredTitle} text={labels.errors.sessionExpired}>
          <button
            onClick={() => { localStorage.removeItem(SESSION_TOKEN_STORAGE_KEY); window.location.href = '/scan'; }}
            className="btn-primary btn-lg"
          >
            <Icon name="scan" size={20} />
            {labels.app.rescan}
          </button>
        </EmptyState>
      </div>
      <footer style={{ display: 'flex', justifyContent: 'center' }}>
        <Logo size={24} withWordmark />
      </footer>
    </main>
  );
}
